module.exports = __webpack_public_path__ + "3928748c4281b6f73338dcdabd6a30c4.png";